import styled from 'styled-components';
import ArrowLeftSvg from './arrow-left.svg';

const ArrowLeftIcon = styled(ArrowLeftSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default ArrowLeftIcon;
